import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: { offlineAvailability: true, fullscreen: true },
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "dashboard",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/userProfile",
      name: "userProfile",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "userProfile" */ "../views/UserProfile.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/associations",
      name: "associations",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "associations" */ "../views/Associations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/associations/:id",
      name: "associationsView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "associationsView" */ "../views/Associations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/associations/:id/members/:member_id",
      name: "associationsMemberView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "associationsMemberView" */ "../views/Associations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/associations/:id/users/:user_id",
      name: "associationsMemberView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "associationsMemberView" */ "../views/Associations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/associations/:id/users/:user_id/permissions/:userPermissions_id",
      name: "associationsUserPermissionsView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "associationsUserPermissionsView" */ "../views/Associations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/events",
      name: "events",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "events" */ "../views/Events.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/competitions",
      name: "competitions",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "competitions" */ "../views/Competitions.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/competitions/:id",
      name: "competitionsView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "competitionsView" */ "../views/Competitions.vue"
        )
    },

    {
      beforeEnter: AuthGuard,
      path: "/reports",
      name: "reports",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "reports" */ "../views/Downloads.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/competitions/:id/events/:events_id",
      name: "competitionsEventView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "competitionsEventView" */ "../views/Competitions.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/waves",
      name: "waves",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "waves" */ "../views/SystemView.vue"),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "competitions",
          name: "competitions",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "competitions" */ "../views/Waves/Competitions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:competitions_id/events",
          name: "wavesCompetitionsMarshalling",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "wavesCompetitionsMarshalling" */ "../views/Waves/Marshalling.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:competitions_id/events/:events_id",
          name: "wavesCompetitionsEventProgress",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "wavesCompetitionsEventProgress" */ "../views/Waves/EventProgress.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:competitions_id/entries",
          name: "wavesCompetitionsEntries",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "wavesCompetitionsEntries" */ "../views/Waves/Entries.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:competitions_id/reports",
          name: "wavesCompetitionsReports",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "wavesCompetitionsReports" */ "../views/Waves/Reports.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:competitions_id/wavesResults",
          name: "wavesCompetitionsWavesResults",
          meta: { offlineAvailability: false, fullscreen: true },
          component: () =>
            import(
              /* webpackChunkName: "wavesCompetitionsWavesResults" */ "../views/Waves/LiveResults.vue"
            )
        }
      ]
    },
    {
      beforeEnter: AuthGuard,
      path: "/entries",
      name: "entries",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "entries" */ "../views/SystemView.vue"),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "competitions",
          name: "competitions",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "competitions" */ "../views/Entries/Competitions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:id",
          name: "competitionsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "competitionsView" */ "../views/Entries/Competitions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:id/enterIndividual/:enterIndividual_id",
          name: "competitionsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "competitionsView" */ "../views/Entries/Competitions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "competitions/:id/enterTeam/:enterTeam_id",
          name: "competitionsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "competitionsView" */ "../views/Entries/Competitions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "members",
          name: "members",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "members" */ "../views/Entries/Members.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "members/:member_id",
          name: "membersView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "membersView" */ "../views/Entries/Members.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "supportTeam",
          name: "supportTeam",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "supportTeam" */ "../views/Entries/SupportTeam.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "supportTeam/:user_id",
          name: "supportTeamView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "supportTeamView" */ "../views/Entries/SupportTeam.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "reports",
          name: "reports",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "reports" */ "../views/Entries/Reports.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "clubInfo",
          name: "clubInfo",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "clubInfo" */ "../views/Entries/ClubInfo.vue"
            )
        }
      ]
    },
    {
      beforeEnter: AuthGuard,
      path: "/management",
      name: "management",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "management" */ "../views/SystemView.vue"),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "divisions",
          name: "divisions",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "divisions" */ "../views/Divisions.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "divisions/:id",
          name: "divisionsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "divisionsView" */ "../views/Divisions.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "disciplines",
          name: "disciplines",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "disciplines" */ "../views/Disciplines.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "disciplines/:id",
          name: "disciplinesView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "disciplinesView" */ "../views/Disciplines.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "questionTypes",
          name: "questionTypes",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "questionTypes" */ "../views/QuestionTypes.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "questionTypes/:id",
          name: "questionTypesView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "questionTypesView" */ "../views/QuestionTypes.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "dqCodes",
          name: "dqCodes",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "dqCodes" */ "../views/DQTypes.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "dqCodes/:id",
          name: "dqCodesView",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "dqCodesView" */ "../views/DQTypes.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "awards",
          name: "awards",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "awards" */ "../views/Awards.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "awards/:id",
          name: "awardsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "awardsView" */ "../views/Awards.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "pointsTable",
          name: "pointsTable",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "pointsTable" */ "../views/PointsTable.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "pointsTable/:id",
          name: "pointsTable",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "pointsTable" */ "../views/PointsTable.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "tutorials",
          name: "tutorials",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "tutorials" */ "../views/Tutorials.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "tutorials/:id",
          name: "tutorialsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "tutorialsView" */ "../views/Tutorials.vue")
        },
      ]
    },
    {
      beforeEnter: AuthGuard,
      path: "/system",
      name: "system",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "siteSettings" */ "../views/SystemView.vue"
        ),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "users",
          name: "users",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "users" */ "../views/Users.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "users/:user_id",
          name: "usersView",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "usersView" */ "../views/Users.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "users/:user_id/permissions/:userPermissions_id",
          name: "userPermissionsView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "userPermissionsView" */ "../views/Users.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "slsnz",
          name: "slsnz",
          meta: { offlineAvailability: false },
          component: () =>
            import(/* webpackChunkName: "slsnz" */ "../views/SLSNZ.vue")
        },
        {
          beforeEnter: AuthGuard,
          path: "documentation",
          name: "documentation",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "documentation" */ "../views/Documentation.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "siteSettings",
          name: "siteSettings",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "siteSettings" */ "../views/SiteSettings.vue"
            )
        }
      ]
    }
  ]
});
